export enum EntityEnum {
    SHIPMENT = 'Shipment',
    CONTACT = 'Contact',
    ADDRESS_BOOK = 'AddressBook',
    PICKUP = 'Pickup',
    ORGANIZATION = 'Organization',
    PACKAGE = 'Package',
    COMMODITY = 'Commodity',
    USER = 'User',
    IDENTITY = 'Identity',
    SHIPMENT_HEADER = 'ShipmentHeader',
    BATCH = 'Batch',
    INVOICE = 'Invoice',
    CREDIT_CARD = 'CreditCard'
}


